module.exports = __webpack_public_path__ + "static/img/img_3.4a64c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/children_gallery/img_3.jpg
// module id = p+tE
// module chunks = 0